import {
	MULTI_VERSION_CF_TYPE,
	VERSION_CF_TYPE,
	AFFECTS_VERSIONS_TYPE,
	FIX_VERSIONS_TYPE,
} from '@atlassian/jira-platform-field-config';
import type { FormatRule, EvaluateHandler } from '../../../evaluate-format-rule/types';
import type { TransformedSingleVersion, TransformedMultipleVersion } from '../types';

// TODO: FLINGO:925 - use value.id once that ticket is done

const evaluateHandler: EvaluateHandler<TransformedSingleVersion> = {
	IS: (field, value) => Boolean(field.value?.name === value),
	IS_NOT: (field, value) => Boolean(field.value?.name !== value),
	IS_EMPTY: (field) => !field.value,
	IS_NOT_EMPTY: (field) => Boolean(field.value),
};

const evaluateFormatRule: FormatRule<TransformedSingleVersion> = ({ field, operator, value }) => {
	const evaluateHandlerFn = evaluateHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

const evaluateMultiVersionHandler: EvaluateHandler<TransformedMultipleVersion> = {
	CONTAINS: (field, value) =>
		Boolean(
			Array.isArray(value) &&
				field.value?.filter((fieldValue) => value?.includes(fieldValue.name)).length ===
					value.length,
		),
	HAS_ANY_OF: (field, value) =>
		Boolean(
			Array.isArray(value) && field.value?.some((fieldValue) => value?.includes(fieldValue.name)),
		),
	DOES_NOT_CONTAIN: (field, value) =>
		!(
			Array.isArray(value) &&
			field.value?.filter((fieldValue) => value?.includes(fieldValue.name)).length === value.length
		),
	IS_EMPTY: (field) => field.value?.length === 0,
	IS_NOT_EMPTY: (field) => Boolean(field.value && field.value?.length > 0),
};

const evaluateFormatRulesForMultiVersion: FormatRule<TransformedMultipleVersion> = ({
	field,
	operator,
	value,
}) => {
	const evaluateHandlerFn = evaluateMultiVersionHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

export const versionEvaluateFormatRule = {
	[VERSION_CF_TYPE]: evaluateFormatRule,
	[MULTI_VERSION_CF_TYPE]: evaluateFormatRulesForMultiVersion,
	[FIX_VERSIONS_TYPE]: evaluateFormatRulesForMultiVersion,
	[AFFECTS_VERSIONS_TYPE]: evaluateFormatRulesForMultiVersion,
};
